import { ApiService } from '../../app-lite/api/api.service';

import CapricornSettingsHtml from './capricorn.settings.html';

export function CapricornStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'CapricornSettingsCtrl',
    name       : 'app.capricorn',
    templateUrl: CapricornSettingsHtml,
    url        : '/capricorn',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations')
    }
  });
}
